/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Sire_DescriptionInputs */



/**
* | output |
* | --- |
* | "OCIMF Ship Inspection Report Exchange inspections under the enhanced, risk-based SIRE 2.0 regime." |
*
* @param {Service_Sire_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_sire_description = /** @type {((inputs?: Service_Sire_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Sire_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("依据强化的、基于风险的 SIRE 2.0 制度开展的 OCIMF 船舶检查报告交换（SIRE）检查。")
	return /** @type {LocalizedString} */ ("OCIMF Ship Inspection Report Exchange inspections under the enhanced, risk-based SIRE 2.0 regime.")
});